import { Loader2 } from 'lucide-react';

type Props = {
  erroreInvio: string | null;
  inviando: boolean;
  testo: string;
  trappola: string;
  onTrappola: (valore: string) => void;
};

/**
 * La fine del modulo: l'errore dell'invio, il pulsante e la trappola per i
 * programmi automatici. In fondo e non in cima: la prima sezione deve restare
 * la prima cosa del foglio.
 */
export function FondoModulo({ erroreInvio, inviando, testo, trappola, onTrappola }: Props) {
  return (
    <>
      {erroreInvio && (
        <p role="alert" className="mt-8 rounded border border-red-200 bg-red-50 px-4 py-3 text-center text-base font-medium text-red-700">
          {erroreInvio}
        </p>
      )}

      <div className="mt-8 flex justify-center">
        <button
          type="submit"
          disabled={inviando}
          className="inline-flex min-w-[16rem] items-center justify-center gap-2 rounded-full bg-primary-600 px-10 py-3 text-2xl font-medium uppercase tracking-wide text-white shadow-lg shadow-primary-600/40 transition hover:bg-primary-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-200 active:scale-[0.98] disabled:opacity-60"
        >
          {inviando && <Loader2 className="h-6 w-6 animate-spin" />}
          {inviando ? 'Invio…' : testo}
        </button>
      </div>

      <input
        type="text"
        name="sito"
        value={trappola}
        onChange={(e) => onTrappola(e.target.value)}
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        className="absolute -left-[9999px] h-px w-px opacity-0"
      />
    </>
  );
}
